var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { staticClass: "elevation-0", staticStyle: { position: "relative" } },
        [
          _c(
            "v-sheet",
            { staticClass: "d-flex bg-surface-variant" },
            [
              _c(
                "v-sheet",
                { staticClass: "me-auto" },
                [
                  _c("v-card-subtitle", [
                    _vm._v(" Easily load any supported Data Format "),
                  ]),
                ],
                1
              ),
              _c("v-sheet", { staticClass: "pr-1 pt-2 primary--text" }, [
                _vm._v("Supported Formats:"),
              ]),
              _c(
                "v-sheet",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "pa-3 pt-4",
                      staticStyle: { cursor: "pointer" },
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.isActiveDialog = true
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            "b-tooltip.hover": "",
                            title: "Heimdall Supported Formats",
                            color: "primary",
                          },
                        },
                        [_vm._v(" mdi-information-outline ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "500" },
                      model: {
                        value: _vm.isActiveDialog,
                        callback: function ($$v) {
                          _vm.isActiveDialog = $$v
                        },
                        expression: "isActiveDialog",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v("Heimdall Supported Formats"),
                          ]),
                          _c(
                            "v-card-text",
                            { staticClass: "text-h7" },
                            [
                              _c("ul", [
                                _c("li", [
                                  _vm._v("InSpec/Heimdall Data Format"),
                                ]),
                                _c("li", [_vm._v("Anchore Grype")]),
                                _c("li", [
                                  _vm._v("AWS Security Finding Format (ASFF)"),
                                ]),
                                _c("li", [_vm._v("Burp Suite")]),
                                _c("li", [_vm._v("Checklist")]),
                                _c("li", [
                                  _vm._v(
                                    "CycloneDX Software Bill of Materials (SBOM)"
                                  ),
                                ]),
                                _c("li", [_vm._v("DBProtect")]),
                                _c("li", [_vm._v("Fortify")]),
                                _c("li", [
                                  _vm._v("Golang Security Checker (gosec)"),
                                ]),
                                _c("li", [_vm._v("Ion Channel")]),
                                _c("li", [_vm._v("JFrog Xray")]),
                                _c("li", [_vm._v("Microsoft Secure Score")]),
                                _c("li", [_vm._v("Nessus")]),
                                _c("li", [_vm._v("Netsparker")]),
                                _c("li", [
                                  _vm._v("NeuVector (Vulnerabilities Only)"),
                                ]),
                                _c("li", [_vm._v("Nikto")]),
                                _c("li", [_vm._v("OWASP ZAP")]),
                                _c("li", [_vm._v("Prisma")]),
                                _c("li", [
                                  _vm._v(
                                    "Static Analysis Results Interchange Format (SARIF)"
                                  ),
                                ]),
                                _c("li", [_vm._v("Scoutsuite")]),
                                _c("li", [_vm._v("Snyk")]),
                                _c("li", [_vm._v("Tenable (API)")]),
                                _c("li", [_vm._v("Trufflehog")]),
                                _c("li", [_vm._v("Twistlock")]),
                                _c("li", [_vm._v("Veracode")]),
                                _c("li", [
                                  _vm._v(
                                    "XCCDF Results (native OpenSCAP and SCC outputs)"
                                  ),
                                ]),
                              ]),
                              _c("v-card-text", [
                                _vm._v(
                                  " For formats not supported please contact us at "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:opensource@mitre.org?subject=Request Additional Format Support",
                                    },
                                  },
                                  [_vm._v("Request Additional Formats")]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.isActiveDialog = false
                                    },
                                  },
                                },
                                [_vm._v("Close Dialog")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-container",
            { staticStyle: { "margin-top": "5%" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", align: "center" } },
                    [
                      _c("v-img", {
                        staticStyle: {
                          "max-width": "164px",
                          "max-height": "164px",
                        },
                        attrs: {
                          src: require("@/assets/logo-orange-tsp.svg"),
                          "svg-inline": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", align: "center" } }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column justify-center" },
                      [
                        _c("span", { class: _vm.title_class }, [
                          _vm._v("Heimdall"),
                        ]),
                        _vm.serverMode
                          ? _c("span", { class: _vm.title_class }, [
                              _vm._v("Server"),
                            ])
                          : _c("span", { class: _vm.title_class }, [
                              _vm._v("Lite"),
                            ]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { align: "center", cols: "12" } }, [
                    _c("div", { staticClass: "caption font-weight-medium" }, [
                      !_vm.loading
                        ? _c(
                            "div",
                            [
                              _c("VueFileAgent", {
                                ref: "vueFileAgent",
                                attrs: {
                                  multiple: true,
                                  "help-text":
                                    "Choose file(s) to upload or drag & drop here",
                                },
                                on: { select: _vm.filesSelected },
                                model: {
                                  value: _vm.fileRecords,
                                  callback: function ($$v) {
                                    _vm.fileRecords = $$v
                                  },
                                  expression: "fileRecords",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "#ff5600",
                                  size: 120,
                                  width: 15,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.percent) + "% loaded"
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }